import { gql } from '@apollo/client';

export const GET_USERS = gql`
  query GetUsers {
    users {
      id
      name
      email
      profession
      location
      skills
      avatarUrl
      telegramLinked
      telegramUsername
      walletAddress
      tonWalletAddress
      followersCount
      followingCount
      twoFactorEnabled
      createdAt
      updatedAt
    }
  }
`;

export const GET_USER = gql`
  query GetUser($id: String!) {
    user(id: $id) {
      id
      name
      email
      age
      profession
      company
      location
      phone
      bio
      skills
      avatarUrl
      telegramLinked
      telegramId
      telegramUsername
      telegramFirstName
      telegramLastName
      telegramPhotoUrl
      telegramLanguageCode
      telegramIsPremium
      telegramLinkedAt
      walletAddress
      walletChainId
      walletConnectedAt
      tonWalletAddress
      tonWalletConnectedAt
      followersCount
      followingCount
      twoFactorEnabled
      shippingCountry
      shippingCity
      shippingAddress
      shippingZipCode
      shippingNotes
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser($updateUserInput: UpdateUserInput!) {
    updateUser(updateUserInput: $updateUserInput) {
      id
      name
      email
      age
      profession
      company
      location
      phone
      bio
      skills
      avatarUrl
      telegramLinked
      telegramId
      telegramUsername
      telegramFirstName
      telegramLastName
      telegramPhotoUrl
      telegramLanguageCode
      telegramIsPremium
      telegramLinkedAt
      walletAddress
      walletChainId
      walletConnectedAt
      tonWalletAddress
      tonWalletConnectedAt
      followersCount
      followingCount
      twoFactorEnabled
      shippingCountry
      shippingCity
      shippingAddress
      shippingZipCode
      shippingNotes
      createdAt
      updatedAt
    }
  }
`;
